export default __webpack_public_path__ + "976dbc07d68bb9ef6a19bdfda61b46e1.svg";